<script>
export default {
  props: ["clr"]
};
</script>
<template
  ><svg
    id="info_icon"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path id="Path_7780" data-name="Path 7780" d="M0,0H16V16H0Z" fill="none" />
    <path
      id="Path_7781"
      data-name="Path 7781"
      d="M9,15H9A6,6,0,0,1,3,9H3A6,6,0,0,1,9,3H9a6,6,0,0,1,6,6h0A6,6,0,0,1,9,15Z"
      transform="translate(-1 -1)"
      fill="none"
      :stroke="clr ? clr : '#3889d0'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
    />
    <path
      id="Path_7782"
      data-name="Path 7782"
      d="M11.667,15.333V12H11"
      transform="translate(-3.667 -4)"
      fill="none"
      :stroke="clr ? clr : '#3889d0'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
    />
    <path
      id="Path_7783"
      data-name="Path 7783"
      d="M11.666,8a.167.167,0,1,0,.167.167A.166.166,0,0,0,11.666,8"
      transform="translate(-3.833 -2.667)"
      fill="none"
      :stroke="clr ? clr : '#3889d0'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
    />
  </svg>
</template>
